import React, { ReactNode, useRef, useState } from 'react';
import { Flex, Loading, ProgressVariant, Tooltip, Text } from '@cko/primitives';
import styled, { css } from 'styled-components';

export type TruncatedTextProps = {
  maxWidth: string;
};

export type TruncatedTextWithTooltipProps = {
  className?: string;
  children?: ReactNode;
  testId?: string;
} & TruncatedTextProps;

// legacy component
export const TruncatedText = styled.div<TruncatedTextProps>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}
`;

export const TruncatedTextWithTooltip = ({
  className,
  children,
  maxWidth,
  testId,
}: TruncatedTextWithTooltipProps) => {
  const ref = useRef<HTMLParagraphElement | null>(null);
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const onMouseOver = () => {
    let isOverflowing = false;
    //the actual component we need to check against is the child of this component.
    const component = ref.current?.children[0];
    if (component) {
      const currentWidth = component.clientWidth;
      const totalWidth = component.scrollWidth;
      isOverflowing = currentWidth < totalWidth;
    }

    if (showTooltip !== isOverflowing) {
      setShowTooltip(isOverflowing);
    }
  };

  const onMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <Tooltip show={showTooltip} text={children}>
      <TruncatedText
        data-testid={testId}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseLeave}
        ref={ref}
        className={className}
        maxWidth={maxWidth}
      >
        {children}
      </TruncatedText>
    </Tooltip>
  );
};
export const SubEntityTooltip = styled(TruncatedTextWithTooltip)`
  color: var(--control-text-primary);
  font: var(--body-xs-emphasis);
  margin-right: var(--layout-seed);
  max-width: 300px;
`;

const LoadingContainer = styled(Flex)`
  gap: var(--layout-soybean);
  align-items: center;
  justify-content: center;
`;

const LoadingText = styled(Text)`
  color: var(--control-text-secondary);
  font: var(--body-xs-medium);
`;

// legacy component
export const StyledLoading = (props: { testId?: string }) => {
  return (
    <LoadingContainer data-testid={props.testId}>
      <Loading variant={ProgressVariant.NESTED} width="16px" />
      <LoadingText>Loading</LoadingText>
    </LoadingContainer>
  );
};
